import Header from './Header'
import Footer from './Footer'
import { useScrollZoom } from '../Dashboard/ui/use-scroll-zoom'
import { useScrollDarkness } from '../Dashboard/ui/use-scroll-darkness'


function Layout({ children }) {

  const scale = useScrollZoom({ maxZoom: 1.15 });
  const darkness = useScrollDarkness({ maxDarkness: 0.7 });

  return (
    <div className="min-h-screen flex flex-col relative">
      {/* Fixed Background Image - Mobile Optimized */}
      {/* <div 
        id="background"
        style={{
          backgroundImage: 'url(/images/gold.jpeg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div 
          className="absolute inset-0" 
          style={{ 
            backgroundColor: `rgba(0, 0, 0, ${overlayOpacity})`,
            transition: 'background-color 0.5s ease-out'
          }}
        ></div>
      </div> */}
      {/* <div 
        id="background"
        >
      </div> */}

      {/* Fixed background with gold image */}
   
      {/* Cave-like gradient overlay - dark with subtle gold glow */}
      {/* <div 
        className="fixed inset-0 z-0"
        style={{
          background: 'radial-gradient(ellipse at top, rgba(10, 8, 6, 0.3) 0%, rgba(10, 8, 6, 0.85) 100%, rgba(10, 8, 6, 0.95) 200%)'
        }}
      /> */}
      
      {/* Subtle gold ambient glow from top */}
      {/* <div 
        className="fixed inset-0 z-0 opacity-20"
        style={{
          background: 'radial-gradient(ellipse 80% 50% at 50% 0%, rgba(255, 191, 0, 0.15) 0%, transparent 60%)'
        }}
      /> */}

      {/* Fixed background with gold image */}
      <div 
        className="fixed top-0 left-0 w-full h-[100vh] z-0 transition-transform duration-100 ease-out origin-center"
        style={{
          backgroundImage: `url(/images/gold.jpeg)`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          transform: `scale(${scale})`,
          minHeight: '100vh',
          height: '100dvh' // Dynamic viewport height for better mobile support
        }}
      />
      
      {/* Cave-like gradient overlay - dark with subtle gold glow */}
      <div 
        className="fixed top-0 left-0 w-full h-[100vh] z-0 transition-transform duration-100 ease-out origin-center"
        style={{
          background: 'radial-gradient(ellipse at top, rgba(10, 8, 6, 0.3) 0%, rgba(10, 8, 6, 0.85) 50%, rgba(10, 8, 6, 0.95) 100%)',
          transform: `scale(${scale})`,
          minHeight: '100vh',
          height: '100dvh'
        }}
      />
      
      {/* Subtle gold ambient glow from top */}
      <div 
        className="fixed top-0 left-0 w-full h-[100vh] z-0 opacity-20 transition-transform duration-100 ease-out origin-center"
        style={{
          background: 'radial-gradient(ellipse 80% 50% at 50% 0%, rgba(255, 191, 0, 0.15) 0%, transparent 60%)',
          transform: `scale(${scale})`,
          minHeight: '100vh',
          height: '100dvh'
        }}
      />

      {/* Progressive darkness overlay - gets darker as you scroll down into the mine */}
      <div 
        className="fixed top-0 left-0 w-full h-[100vh] z-0 pointer-events-none transition-opacity duration-300 ease-out"
        style={{
          backgroundColor: 'rgba(0, 0, 0, 1)',
          opacity: darkness,
          minHeight: '100vh',
          height: '100dvh'
        }}
      />
      
      <div className="relative z-10 flex flex-col min-h-screen">
        <Header />
        <main className="flex-grow">
          {children}
        </main>
        <Footer />
      </div>
    </div>
  )
}

export default Layout 